// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__xZ8aV","container":"styles_container__2LR2P","title":"styles_title__3724s","wrapper":"styles_wrapper__l1f3l","answer":"styles_answer__2TqSu"};